import { EditorState } from 'draft-js';
import actionTypes from '../actionTypes';

const initialState = {
  email: {
    editorState: EditorState.createEmpty(),
    defaultTo: [],
    defaultcc: [],
    defaultBcc: [],
    subject: "",
  },
  sms: {},
  // activeTab: 1,
};

export default (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    case actionTypes.EMAIL:
      newState.email = {...state.email};
      newState.email[action.payload.data.key] = action.payload.data.value;
      return newState;
    // case actionTypes.SMS:
    //   newState.sms[action.payload.data.key] = action.payload.data.value;
    //   return newState;
    case actionTypes.SMS:
      newState.sms = { ...state.sms };
      newState.sms[action.payload.data.key] = action.payload.data.value;
      return newState;
    // case actionTypes.ACTIVE_TAB:
    //   newState.activeTab = action.payload.data;
    //   return newState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/store/reducers/smsemail.reducer.js